import React from 'react';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import {SnackbarProvider, SnackbarProviderProps} from 'notistack';

export default function NotiStackProvider(props: SnackbarProviderProps) {
    const {children, ...rest} = props;
    const iconStyle = {marginRight: 16};

    const iconVariants = {
        success: <ErrorOutlineRoundedIcon style={iconStyle} />,
        error: <ErrorOutlineRoundedIcon style={iconStyle} />,
        warning: <WarningRoundedIcon style={iconStyle} />,
        info: <WarningRoundedIcon style={iconStyle} />,
    };

    return (
        <SnackbarProvider
            {...rest}
            maxSnack={4}
            autoHideDuration={4000}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            iconVariant={iconVariants}>
            {children}
        </SnackbarProvider>
    );
}
